module.exports = __webpack_public_path__ + "media/images/front/icons/logout-7d66a288cde0adec8197941051b2a5de.png";